import { DonutChartData, DonutLegendItem } from '../types'

export const filterEmptyDonutCategories = <T>(legend: DonutLegendItem[], data: DonutChartData<T>[] = []) => {
    if (legend.length === 0) return { legend, data }

    const legendDataCount = legend.map((_, legendItemIndex) =>
        data.reduce((sum, chart) => sum + (chart.values[legendItemIndex].count ?? 0), 0)
    )

    const filteredLegend = legend.filter((_, i) => legendDataCount[i] > 0)

    const filteredData = data.map((data) => ({
        ...data,
        values: data.values.filter((_, i) => legendDataCount[i] > 0),
    }))

    return {
        filteredLegend,
        filteredData,
    }
}
